//require('dotenv').config();

let api = 'https://apifc.venturesoftware.cl/';

if(window.location.host.match('localhost')){
    api = 'http://localhost:4004/';
}

export default{
    api,
    config : {headers: {'Bearer ': sessionStorage.token}}
}